import { Component, Input, OnInit, ChangeDetectorRef, Optional } from '@angular/core';
import { AuthServiceService } from '@services/auth-service.service';
import { RegUser } from '../../pages/basic-reg/RegUser';
import { Globals } from 'src/app/globals';

import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileModalComponent } from '@modal/profile-modal/profile-modal.component';
import { LoaderService } from '@services/loader.service';
import { CommonUtil } from 'src/app/util/CommonUtil';
import { TimeZoneUtils } from 'src/app/util/TimeZoneUtils';
import { CommunicationConstants } from 'src/app/constants/CommunicationConstants';

import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact-setting',
  templateUrl: './contact-setting.component.html',
  styleUrls: ['./contact-setting.component.scss', '../../../assets/css/style.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule],
})
export class ContactSettingComponent {
  requestPath: string;
  errorMessage!: string;

  loggedInUser!: RegUser;

  selectedTab = 'tab1';
  selectedCategory = 'friends';
  select: boolean = true;
  timeSlotType = 'Custom';

  ownerId!: any;
  preferredTimeSlotToDisplay = [];
  preferredCommChanelToDisplay = [];
  isOlderTime!: any;

  fromTime!: any;
  toTime!: any;
  selectAllTimeSlots = false;
  currentUserTimeZone: string = 'UTC';

  @Input("user") user!: any;
  @Input("personalizedMsg") personalizedMsg!: any;
  @Input("isSender") isSender!: any;
  @Input("isAddButtonVisible") isAddButtonVisible!: any;

  constructor(private authService: AuthServiceService,
    public global: Globals,
    @Optional() public activeModal: NgbActiveModal,
    @Optional() private modalCtrl: ModalController,
    private modalService: NgbModal,
    private router: Router,
    private loader: LoaderService,
    private cdr: ChangeDetectorRef) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit(): void {
    this.loggedInUser = this.authService.getLoggedInUser();
    this.ownerId = this.loggedInUser.id;
    this.currentUserTimeZone = this.loggedInUser.timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC';
    this.errorMessage = "";
    this.selectAllCommChanel();
  }

  ionViewDidEnter() {
    // console.log(this.user);
    // console.log(this.personalizedMsg);
    // console.log(this.isSender);
    // console.log(this.isAddButtonVisible);
    // For testing only, need to comment this line
    // var arr = "1,4,22".split(",");
    // this.markTimeSlotSelected(arr);
  }

  dismiss(data: any) {
    if (this.activeModal) {
      this.activeModal.close(data);
      return;
    }

    if (this.modalCtrl) {
      this.modalCtrl.dismiss(data);
    }
  }

  openProfileModal(userData: any) {
    this.dismiss('');
    if (this.isSender) {
      const modalRef = this.modalService.open(ProfileModalComponent, {
        centered: true,
        size: 'md'
      });
      modalRef.componentInstance.user = userData;
      modalRef.componentInstance.personalizedMsg = this.personalizedMsg;
      modalRef.componentInstance.isAddButtonVisible = this.isAddButtonVisible;

      modalRef.result.then((dataReturned) => {
        // this.router.navigateByUrl("dashboard");
      }).catch(() => {});
    }
  }

  changeTimeSlot(val: any) {
    this.timeSlotType = val;
    this.selectAllTimeSlots = false;
    this.markAllTimeSlots(false);
  }

  changeTimeSelectionType(event: any) {
    var val = event.target.checked;
    this.selectAllTimeSlots = val;
    this.markAllTimeSlots(val);
  }

  changeCategory(val: any) {
    this.selectedCategory = val;
  }

  changeTab(tab: any) {
    this.selectedTab = tab;
  }

  markChecked(id: any) {
    for (var timeSlot of this.timeSlotsCol1) {
      if (timeSlot.id == id) {
        timeSlot.checked = !timeSlot.checked;
        return;
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (timeSlot.id == id) {
        timeSlot.checked = !timeSlot.checked;
        return;
      }
    }
  }

  markAllTimeSlots(checked: any) {
    for (var timeSlot of this.timeSlotsCol1) {
      timeSlot.checked = checked;
    }
    for (var timeSlot of this.timeSlotsCol2) {
      timeSlot.checked = checked;
    }
  }

  getUserPreferredTime() {
    var preferredTimeSlots = "";
    for (var timeSlot of this.timeSlotsCol1) {
      if (timeSlot.checked) {
        preferredTimeSlots += this.convertTimeSlotToUTC(timeSlot.value) + ",";
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (timeSlot.checked) {
        preferredTimeSlots += this.convertTimeSlotToUTC(timeSlot.value) + ",";
      }
    }
    return preferredTimeSlots.substring(0, preferredTimeSlots.length - 1);
  }

  selectAllCommChanel() {
    for (var commType of this.communicationTypes) {
      commType.checked = true;
    }
  }

  convertTimeSlotToUTC(timeRange: string) {
    let splittedData = timeRange.split("-");
    if (splittedData.length != 2) {
      console.log("Invalid time range: " + timeRange);
      return timeRange;
    }
    return TimeZoneUtils.convertOnlyTimeToUTC(splittedData[0] ?? '', this.currentUserTimeZone) + "-" + TimeZoneUtils.convertOnlyTimeToUTC(splittedData[1] ?? '', this.currentUserTimeZone);
  }

  getPreferredCommChannel() {
    var preferredcommChanels = "";
    for (var commType of this.communicationTypes) {
      if (commType.checked) {
        preferredcommChanels += commType.id + ",";
      }
    }
    return preferredcommChanels.substring(0, preferredcommChanels.length - 1);
  }

  markTimeSlotSelected(ids: any) {
    for (var timeSlot of this.timeSlotsCol1) {
      if (ids.indexOf(timeSlot.id + "") > -1) {
        timeSlot.checked = true;
      }
    }
    for (var timeSlot of this.timeSlotsCol2) {
      if (ids.indexOf(timeSlot.id + "") > -1) {
        timeSlot.checked = true;
      }
    }
  }

  changeChanel(id: any) {
    for (var commType of this.communicationTypes) {
      if (commType.id == id) {
        commType.checked = !commType.checked;
        return;
      }
    }
  }

  addContact() {
    // Clear previous error message
    this.errorMessage = '';
    
    let preferredTimeSlots: string = '';
    let preferredChanel: string = '';
    if (this.timeSlotType == "Custom") {
      if (CommonUtil.isEmptyTrim(this.fromTime)) {
        this.errorMessage = "Please select preferred time slots.";
        this.cdr.detectChanges();
        return;
      }
      if (CommonUtil.isEmptyTrim(this.toTime)) {
        this.errorMessage = "Please select preferred communication channels.";
        this.cdr.detectChanges();
        return;
      }
      preferredTimeSlots = '';
      preferredChanel = this.getPreferredCommChannel();
    } else {
      preferredTimeSlots = this.selectAllTimeSlots ? "All" : this.getUserPreferredTime();
      preferredChanel = this.getPreferredCommChannel();
      if (CommonUtil.isEmptyTrim(preferredTimeSlots)) {
        this.errorMessage = "Please select preferred time slots.";
        this.cdr.detectChanges();
        return;
      }
      if (CommonUtil.isEmptyTrim(preferredChanel)) {
        this.errorMessage = "Please select preferred communication channels.";
        this.cdr.detectChanges();
        return;
      }
    }

    if (this.isSender) {
      let userContact = {
        "ownerId": this.ownerId,
        "contactId": this.user.id,
        "senderCategory": this.selectedCategory,
        "status": "Requested",
        "senderStartTime": '',
        "senderEndTime": '',
        "senderPrefTime": '',
        "senderCommChanel": '',
        "isFavorite": false,
        "personalizedMsg": this.personalizedMsg
      };
      userContact.senderCommChanel = this.getPreferredCommChannel();
      if (this.timeSlotType == "Custom") {
        userContact.senderStartTime = TimeZoneUtils.convertOnlyTimeToUTC(String(this.fromTime ?? ''), this.currentUserTimeZone);
        userContact.senderEndTime = TimeZoneUtils.convertOnlyTimeToUTC(String(this.toTime ?? ''), this.currentUserTimeZone);
      } else {
        userContact.senderPrefTime = preferredTimeSlots;
      }
      this.createContact(userContact);
    } else {
      let userContact = {
        "ownerId": this.ownerId,
        "contactId": this.user.id,
        "recieverCategory": this.selectedCategory,
        "status": "Requested",
        "recieverStartTime": '',
        "recieverEndTime": '',
        "recieverPrefTime": '',
        "recieverCommChanel": '',
        "isFavorite": false,
        "personalizedMsg": this.personalizedMsg
      };
      userContact.recieverCommChanel = this.getPreferredCommChannel();
      if (this.timeSlotType == "Custom") {
        userContact.recieverStartTime = TimeZoneUtils.convertOnlyTimeToUTC(this.fromTime ?? '', this.currentUserTimeZone);
        userContact.recieverEndTime = TimeZoneUtils.convertOnlyTimeToUTC(this.toTime ?? '', this.currentUserTimeZone);
      } else {
        userContact.recieverPrefTime = preferredTimeSlots;
      }
      this.dismiss(userContact);
    }

  }

  approve() {
    var preferredTimeSlots = this.getUserPreferredTime();
    var preferredChanel = this.getPreferredCommChannel();

    if (CommonUtil.isEmptyTrim(preferredTimeSlots)) {
      this.errorMessage = "Please select preferred time slots.";
      return;
    }

    if (CommonUtil.isEmptyTrim(preferredChanel)) {
      this.errorMessage = "Please select preferred communication channels.";
      return;
    }
    this.dismiss('OK');
  }

  createContact(userContact: any) {
    this.loader.show("Please wait...");
    this.authService.postEncrypt('user/directory?' + this.requestPath + '=save', userContact)
      .subscribe((res: any) => {
        this.loader.hide();
        if (res.success) {
          // Close modal and move to pending request page
          this.dismiss('');
          this.router.navigate(['pending-request-new']);
        } else {
          this.errorMessage = res.message;
          this.cdr.detectChanges();
        }
      }, (error: any) => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  timeSlotsCol1 = CommunicationConstants.timeSlotsCol1;
  timeSlotsCol2 = CommunicationConstants.timeSlotsCol2;
  communicationTypes = CommunicationConstants.communicationTypes;
}
